var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFt03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 23.9579C62 24.7367 61.3698 25.3631 60.5909 25.3631H56.3636V50.7279C59.4722 50.7279 62 53.2554 62 56.3636V60.5905C62 61.3694 61.3698 61.9995 60.5909 61.9995H1.40913C0.630259 61.9995 0 61.3693 0 60.5905V56.3636C0 53.2554 2.52777 50.7279 5.6364 50.7279V25.3631H1.40913C0.630259 25.3631 0 24.7367 0 23.9579V18.3222C0 17.8255 0.26143 17.3644 0.689441 17.1113L28.2519 0.739255C30.0642 -0.258248 31.9962 -0.22945 33.7094 0.719968L33.7112 0.720975C33.7229 0.727512 33.7347 0.734113 33.7465 0.742029L61.3106 17.1113C61.7386 17.3646 62 17.8255 62 18.3222V23.9579ZM59.1818 59.1812V56.3631C59.1818 54.8095 57.9171 53.5448 56.3636 53.545H54.9545H7.0454H5.63627C4.08275 53.545 2.81813 54.8096 2.81813 56.3631V59.1812H59.1818ZM8.45454 25.3631V50.7267H14.0909V25.3631H8.45454ZM16.9091 25.3631V50.7267H25.3636V25.3631H16.9091ZM28.1817 25.3631V50.7267H33.8181V25.3631H28.1817ZM36.6363 25.3631V50.7267H45.0908V25.3631H36.6363ZM47.9091 25.3631V50.7267H53.5455V25.3631H47.9091ZM2.81813 19.1199V22.545H59.1818V19.1199L32.3279 3.16993C31.4609 2.69793 30.528 2.69661 29.6501 3.17958L2.81813 19.1199ZM25.3582 14.0905C25.3582 10.9805 27.8874 8.45128 30.9974 8.45128C34.1072 8.45128 36.6364 10.9806 36.6364 14.0905C36.6364 17.2003 34.1073 19.7295 30.9974 19.7295C27.8874 19.7295 25.3582 17.2004 25.3582 14.0905ZM28.1764 14.0905C28.1764 15.6454 29.4424 16.9114 30.9974 16.9114C32.5523 16.9114 33.8183 15.6454 33.8183 14.0905C33.8183 12.5355 32.5523 11.2695 30.9974 11.2695C29.4424 11.2695 28.1764 12.5355 28.1764 14.0905Z",
    fill: "url(#paint0_linear_1661_310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1661_310",
    x1: 31,
    y1: -0.000488304,
    x2: 30.998,
    y2: 63.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt03);
export default __webpack_public_path__ + "static/media/ft_03.00b586b023256b76c223ec5f0662a9e3.svg";
export { ForwardRef as ReactComponent };